<template>
    <div class="edit-profile">
        <div class="edits">
            <div class="heading2-section">
                Edit Password
            </div>
        <form>
         <div class="mb-3">
            <label class="form-label">Old Password</label>
            <input type="password" class="form-control">
        </div>
         <div class="mb-3">
            <label class="form-label">New Password</label>
            <input type="password" class="form-control">
        </div>
          <div class="mb-3">
            <label class="form-label">Confirm New Password</label>
            <input type="password" class="form-control">
        </div>
         <div class="form-buttons mb-3">

                <button class="btn btn-default primary-btn primary-btn-disabled">Save New Password</button>
                <!-- <button class="btn btn-default primary-btn">Add Work</button> -->
            </div>
            <ErrorMessages messages="years"/>
        </form>
        <LoadingIndicator/>
        <SystemMessage message="WHATCEdsfd "/>
        </div>
    </div>
</template>
<script>
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import ErrorMessages from '@/components/Utility/ErrorMessages.vue';
export default {
    components:{
        ErrorMessages, LoadingIndicator, SystemMessage
    }
}
</script>
<style scoped>

.edit-profile{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin:4.5rem 0rem;
}

.edits{
    grid-column:2/3;
}

    .select-dates, .select-date{
    display: flex;
    
}

.select-date{
    column-gap:0.5rem;
}

.select-dates{
    row-gap:0.8rem;
    align-items: flex-start;
    flex-direction: column;
}

select{
    min-width:9rem;
}

@media (max-width:768px) {
    .edits{
    grid-column:1/4;
    margin:0rem 0.8rem;
}
}
</style>